import { IS_STANDALONE } from "./standalone/config";
import PlatformAppGate from "./corporate_portal/PlatformAppGate";
import StandaloneApp from "./standalone/StandaloneApp";

function App() {
  return IS_STANDALONE ? <StandaloneApp /> : <PlatformAppGate />;
}

export default App;
